'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import promise from '../utils/promise';
import _map from 'lodash/map';

class ListProducts extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            data: null
        }
    }

    componentDidMount()
    {
        this.getData( this.props );
    }

    componentWillReceiveProps(nextProps)
    {
        if (this.props.url !== nextProps.url)
            this.getData( nextProps );
    }

    getData(props)
    {
        const { url } = props;

        if (!url)
            return;

        promise(url)
        .then( response => {
            this.setState({
                data: response.data.data
            })
        })
        .catch( error => {
            console.log(error);
        })
    }

    render()
    {
        const { data } = this.state;

        if ( !data )
            return null;

        return (
            <section className="box-sugestions">
                <div className="container">
                    <div className="grid-sugestions">
                    { _map( data, (item, index) => {
                        return (
                            <div key={ index } className="text-center item-sugg">
                                <div className="wrap-item" key={ index }>
                                    <a href={ item.url }>
                                        <picture className="picture img-wrap">
                                            <source className="source" media="(min-width: 769px)" srcSet={ item.thumb } />
                                            <img src={ item.thumb } alt={ item.name } />
                                        </picture>
                                    </a>
                                    <p>{ item.name }</p>
                                </div>
                            </div>
                            )
                        })}
                    </div>
                </div>
            </section>
        );
    }
}

ListProducts.propTypes = {
    url: PropTypes.string,
}

export default ListProducts;


// WEBPACK FOOTER //
// ./resources/assets/js/app/components/ListProducts.js